import { render } from "./PdfTemplateIndex.vue?vue&type=template&id=5c36035d"
import script from "./PdfTemplateIndex.vue?vue&type=script&lang=js"
export * from "./PdfTemplateIndex.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__